import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomPanel, {atomPanelColors, atomPanelElevation, atomPanelRounded} from '@s-ui/react-atom-panel'

const BASE_CLASS = 'mt-PanelBasic'

export const PanelBasic = ({
  children,
  isMarginless = false,
  isPaddingless = false,
  isHorizontalPaddingless = false,
  color,
  rounded,
  elevation,
  withBorder = false,
  isBorderlessTop = true,
  ...rest
}) => {
  const className = cx(
    BASE_CLASS,
    isMarginless && `${BASE_CLASS}--marginless`,
    isBorderlessTop && `${BASE_CLASS}--borderless-top`,
    rest.className
  )

  const atomPanelProps = {
    ...rest,
    ...(color ? {color} : {color: atomPanelColors.CANVAS}),
    ...(rounded ? {rounded} : {rounded: atomPanelRounded.L}),
    ...(elevation ? {elevation} : {elevation: atomPanelElevation.M}),
    isFullHeight: true
  }

  const innerWrapperBaseClassName = `${BASE_CLASS}-innerWrapper`
  const innerWrapperClassNames = cx(innerWrapperBaseClassName, {
    [`${innerWrapperBaseClassName}--paddingless`]: isPaddingless,
    [`${innerWrapperBaseClassName}--horizontalPaddingless`]: isHorizontalPaddingless,
    [`${innerWrapperBaseClassName}--withBorder`]: withBorder,
    [`${innerWrapperBaseClassName}--rounded-${rounded}`]: rounded
  })

  return (
    <div className={className}>
      <AtomPanel {...atomPanelProps}>
        {isPaddingless ? children : <div className={innerWrapperClassNames}>{children}</div>}
      </AtomPanel>
    </div>
  )
}

PanelBasic.displayName = 'PanelBasic'
PanelBasic.propTypes = {
  color: PropTypes.string,
  rounded: PropTypes.string,
  elevation: PropTypes.string,
  children: PropTypes.children,
  isMarginless: PropTypes.bool,
  isPaddingless: PropTypes.bool,
  isHorizontalPaddingless: PropTypes.bool,
  withBorder: PropTypes.bool,
  isBorderlessTop: PropTypes.bool
}

export default PanelBasic
